export const base = '/requests';

export const requestsLanding = `${base}`;

export const ceaseBase = `${base}/cease`;
export const ceaseList = `${ceaseBase}`;
export const submitCease = `${ceaseBase}/new`;
export const ceaseById = (id: string) => `${ceaseBase}/${id}`;
